import produce from 'immer'
import { assign, find, findIndex, forEach, map, size } from 'lodash'

import { areSameValue } from '../../../core/utils'

import {
  BULK_UPDATE_LOCATIONS,
  FETCH_LOCATIONS,
  UPDATE_LOCATION,
  UPDATE_LOCATION_STATUS_FLAG,
  UPDATE_LOCATION_TABLE_HOTKEYS,
} from '../action-types'
import { LOCATIONS_INITIAL_STATE } from '../initial-states'

const locationsReducer = (state = LOCATIONS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOCATIONS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_LOCATIONS.COMPLETE:
      return produce(state, nextState => {
        const results = action.payload.data.locations

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
        })
      })

    case FETCH_LOCATIONS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case FETCH_LOCATIONS.CLEANUP:
      return { ...LOCATIONS_INITIAL_STATE }

    case UPDATE_LOCATION.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          error: undefined,
          isLoading: true,
        })
      })

    case UPDATE_LOCATION.COMPLETE:
      return produce(state, nextState => {
        const { updateLocation: location } = action.payload.data

        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, location.id),
        )

        assign(nextState.data?.result[index], {
          ...location,
          isLoading: false,
          error: undefined,
        })
      })

    case UPDATE_LOCATION.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          error: action.error.message,
          isLoading: false,
        })
      })

    case UPDATE_LOCATION_STATUS_FLAG.START:
      return produce(state, nextState => {
        if (size(action.payload.ids) === 1) {
          const index = findIndex(state?.data?.result, ({ id }) =>
            areSameValue(id, action.payload.ids[0]),
          )
          assign(nextState.data?.result[index], {
            error: undefined,
          })
        } else {
          assign(nextState, {
            error: undefined,
          })
        }
      })

    case UPDATE_LOCATION_STATUS_FLAG.COMPLETE:
      return produce(state, nextState => {
        const { updateLocationsStatusFlags: locations } = action.payload.data

        forEach(locations, location => {
          const index = findIndex(state?.data?.result, ({ id }) =>
            areSameValue(id, location.id),
          )

          assign(nextState.data?.result[index], {
            ...location,
            error: undefined,
          })
        })
      })

    case UPDATE_LOCATION_STATUS_FLAG.FAIL:
      return produce(state, nextState => {
        if (size(action.payload.ids) === 1) {
          const index = findIndex(state?.data?.result, ({ id }) =>
            areSameValue(id, action.payload.ids[0]),
          )
          assign(nextState.data?.result[index], {
            error: action.error.message,
          })
        } else {
          assign(nextState, {
            error: action.error.message,
          })
        }
      })

    case UPDATE_LOCATION_TABLE_HOTKEYS:
      return produce(state, nextState => {
        assign(nextState.hotkeys, action.payload)
      })

    case BULK_UPDATE_LOCATIONS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )
    case BULK_UPDATE_LOCATIONS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: action.error.message,
        }),
      )
    case BULK_UPDATE_LOCATIONS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: {
            ...nextState.data,
            result: map(nextState.data.result, oldLocation => {
              const newLocation = find(
                action.payload.data.bulkUpdateLocations,
                location => location.id === oldLocation.id,
              )
              return newLocation || oldLocation
            }),
          },
        }),
      )

    default:
      return state
  }
}

export default locationsReducer
